import { observeDarkMode } from 'bits/dark_mode'
import debounce from 'lodash.debounce'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const browser = namespace('browser')

@Component
export default class extends Vue {
  private unobserveDarkMode
  @browser.Action private toggleDarkMode

  mounted(): void {
    this.unobserveDarkMode = observeDarkMode(debounce(this.toggleDarkMode, 100))
  }

  beforeDestroy(): void {
    this?.unobserveDarkMode()
  }
}
